/* Collett v3 — "Meer laden" op collectie- en zoekpagina's.

   Mobiel is bijna al het verkeer en Nike telt veertien pagina's; doorklikken is
   waar mensen afhaken. Deze laag haalt de volgende pagina op en plakt de
   kaarten erachter.

   Bewust een verbetering bovenop een werkende link, niet in plaats daarvan:
   zonder JS blijft het een gewone <a> naar ?page=2, en dat is ook wat Google
   volgt. De knop houdt daarom zijn href.                                     */
(() => {
  'use strict';

  const knop = document.querySelector('#meer');
  const raster = document.querySelector('#raster') || document.querySelector('.raster')
    || document.querySelector('.blogrij');
  if (!knop || !raster) return;

  const spoor = document.querySelector('.laadmeer__spoor i');
  const stand = document.querySelector('.laadmeer p');
  const rust = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let bezig = false;

  /* Totaal uit de standregel boven het raster ("1.234 artikelen"), zodat de
     teller klopt zonder dat we het aantal hier nog eens hardcoderen. */
  /* Elke keer opnieuw lezen in plaats van één keer bij het laden: na het
     filteren staat er een ander totaal boven het raster. */
  const totaalNu = () => {
    const el = document.querySelector('.stand b');
    if (!el) return null;
    const n = parseInt(el.textContent.replace(/\D/g, ''), 10);
    return Number.isFinite(n) ? n : null;
  };

  const bijBegin = raster.querySelectorAll('.pc-kaart, .kaart, .post').length;
  const standBoven = document.querySelector('.stand');

  const bijwerken = () => {
    const totaal = totaalNu();
    const nu = raster.querySelectorAll('.pc-kaart, .kaart, .post').length;
    if (stand && totaal) stand.textContent = `${nu} van ${totaal} getoond`;
    if (spoor && totaal) spoor.style.transform = `scaleX(${Math.min(1, nu / totaal)})`;
    /* Zodra er is aangevuld klopt "pagina 1 van 14" niet meer: je kijkt dan naar
       meer dan een pagina. Die regel beschrijft de server-gerenderde pagina, dus
       die vervangen we door het aantal. */
    if (standBoven && totaal && nu > bijBegin) {
      standBoven.innerHTML = `<b>${totaal}</b> artikelen`;
    }
  };

  knop.addEventListener('click', async (e) => {
    /* Laat een klik met een modificatietoets of middenklik gewoon een link zijn:
       dan wil iemand hem in een nieuw tabblad. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (bezig) return;

    const url = knop.getAttribute('href');
    if (!url) return;

    bezig = true;
    const tekst = knop.textContent;
    knop.textContent = 'Bezig…';
    knop.setAttribute('aria-busy', 'true');

    try {
      const html = await fetch(url, { headers: { Accept: 'text/html' } }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      });
      const verse = new DOMParser().parseFromString(html, 'text/html');
      const nieuwRaster = verse.querySelector('#raster') || verse.querySelector('.raster')
        || verse.querySelector('.blogrij');
      const kaarten = nieuwRaster ? [...nieuwRaster.children] : [];

      if (!kaarten.length) throw new Error('leeg');

      /* Het eerste nieuwe item krijgt focus zodra het staat, anders springt een
         toetsenbordgebruiker terug naar het begin van de lijst. */
      const eerste = kaarten[0];
      kaarten.forEach((k) => {
        if (!rust) {
          k.style.opacity = '0';
          k.style.transform = 'translateY(8px)';
        }
        raster.appendChild(k);
      });

      if (!rust) {
        requestAnimationFrame(() => {
          kaarten.forEach((k, i) => {
            k.animate(
              [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
              { duration: 320, delay: Math.min(i * 25, 300), easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'both' }
            );
          });
        });
      }

      bijwerken();

      /* De volgende pagina komt uit de opgehaalde pagina zelf, niet uit een
         eigen teller: dan blijft het kloppen als er intussen iets wijzigt. */
      const volgende = verse.querySelector('#meer');
      if (volgende && volgende.getAttribute('href')) {
        knop.setAttribute('href', volgende.getAttribute('href'));
        knop.textContent = tekst;
      } else {
        knop.remove();
      }

      const link = eerste.querySelector('a');
      if (link) link.setAttribute('tabindex', '-1');
      if (link) link.focus({ preventScroll: true });
    } catch (err) {
      /* Mislukt het, dan mag de link gewoon zijn werk doen. */
      knop.textContent = 'Opnieuw proberen';
      setTimeout(() => { knop.textContent = tekst; }, 2000);
    } finally {
      bezig = false;
      knop.removeAttribute('aria-busy');
    }
  });

  bijwerken();
})();
